import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IncludesPipe } from './includes.pipe';

@NgModule({
  declarations: [IncludesPipe],
  imports: [CommonModule],
  exports: [IncludesPipe]
})
export class IncludesModule {}
